import {Component, Input, OnInit} from '@angular/core';
import {CerfComment} from '../../interfaces/CerfComment';
import {getLocalDateTimeString} from '../../../utilities/utils';

@Component({
  selector: 'app-cerf-comment',
  templateUrl: './cerf-comment.component.html',
  styleUrls: ['./cerf-comment.component.scss']
})
export class CerfCommentComponent implements OnInit {
  @Input()
  public comment: CerfComment;
  constructor() { }

  ngOnInit() {
  }

  public getUserInitials() {
    const name =  this.comment.user.name;
    if (name.indexOf(' ') === -1) {
      return name.substring(0, 1)
    }
    const parts = name.split(/\s+/);
    return parts[0].substring(0, 1) + parts[1].substring(0, 1)
  }

  public getAuthorText() {
    if (this.comment.user) {
      return this.comment.user.name;
    }
    return 'System';
  }

  public getDate() {
    return getLocalDateTimeString(this.comment.created_at);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/cerf-comment/cerf-comment.component.ts